import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faPaperPlane,
  faMapMarkerAlt,
  faMobileAlt,
} from '@fortawesome/free-solid-svg-icons'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

function Contact() {
  const [mailForm, setMailForm] = useState({
    name: '',
    email: '',
    message: '',
  })
  const [status, setStatus] = useState('')

  useEffect(() => {
    AOS.init({
      disable: window.innerWidth < 768,
    })
  }, [])

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setMailForm({ ...mailForm, [e.target.name]: e.target.value })
  }

  const submitForm = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setStatus('sending')

    try {
      const response = await fetch('https://formspree.io/meqpjajk', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(mailForm),
      })

      if (response.ok) {
        setStatus('success')
        setMailForm({ name: '', email: '', message: '' })
      } else {
        setStatus('error')
      }
    } catch {
      setStatus('error')
    }
  }

  return (
    <section className="contact" id="contact">
      <div className="contact-container">
        <div className="section-header">
          <span className="section-tag">Get In Touch</span>
          <h2 className="section-title">Contact Me</h2>
          <div className="section-line"></div>
        </div>

        <div className="contact-content">
          <div className="contact-info" data-aos="fade-right">
            <h3>Let's talk about your project</h3>
            <p>
              I'm always interested in hearing about new projects and
              opportunities. Whether you have a question or just want to say hi,
              feel free to reach out!
            </p>

            <div className="contact-item">
              <FontAwesomeIcon icon={faPaperPlane as IconProp} />
              <span
                onClick={() => (window.location.href = 'mailto:freddy.clavijo@gmail.com')}
              >
                freddy.clavijo@gmail.com
              </span>
            </div>

            <div className="contact-item">
              <FontAwesomeIcon icon={faMobileAlt as IconProp} />
              <span
                onClick={() => (window.location.href = 'tel:+61416844858')}
              >
                +61 0416 844 858
              </span>
            </div>

            <div className="contact-item">
              <FontAwesomeIcon icon={faMapMarkerAlt as IconProp} />
              <span>Melbourne, VIC, Australia</span>
            </div>
          </div>

          <form
            className="contact-form"
            onSubmit={submitForm}
            data-aos="fade-left"
          >
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={mailForm.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={mailForm.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <textarea
                name="message"
                placeholder="Your Message"
                value={mailForm.message}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit" className="form-submit" disabled={status === 'sending'}>
              {status === 'sending' ? 'Sending...' : 'Send Message'}
            </button>

            {status === 'success' && (
              <p style={{ color: '#27c93f', marginTop: '10px' }}>
                Message sent successfully!
              </p>
            )}

            {status === 'error' && (
              <p style={{ color: '#ff5f56', marginTop: '10px' }}>
                Something went wrong. Please try again.
              </p>
            )}
          </form>
        </div>
      </div>
    </section>
  )
}

export default Contact
